// extracted by mini-css-extract-plugin
module.exports = {"messages":"MessagesProvider_messages__1kUvL","top":"MessagesProvider_top__m4uQ3","bottom":"MessagesProvider_bottom__CGq7-"};